import React from "react";
import { Typography } from "@mui/material";

import "./error.css";

export default function ForbiddenPage() {
  return (
    <div
      className="admin-error"
    >
      <Typography className="code">
        403
      </Typography>
      <Typography className="title">
        Forbidden
      </Typography>
      <Typography className="description">
        The page you are trying to access has restricted access. Please contact your system administrator for assistance.
      </Typography>
    </div>
  );
}
